var map = {
	"./bingo.png": 51673,
	"./blockchain.png": 96284,
	"./cards.png": 39613,
	"./favorites.png": 80939,
	"./fishing.png": 31046,
	"./live.png": 8568,
	"./mini.png": 42887,
	"./popular.png": 4075,
	"./providers.png": 11634,
	"./recent.png": 65027,
	"./slots.png": 90663,
	"./sports.png": 80251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12225;